import httpClient from "@/store/httpClient";

export default {
    namespaced: true,
    state: {
        items: []
    },
    mutations: {
        SET_ITEMS(state, items) {
            state.items = items;
        }
    },
    getters: {
        itemById: state => id => {
            return state.items.find(item => item.id === id);
        }
    },
    actions: {
        async fetchItems({ commit }) {
            const response = await httpClient.get('/social-media-items/list-items');
            commit('SET_ITEMS', response.data);
        }
    }
}
